import React from 'react';
import PropTypes from 'prop-types';

const PromotionGroupOptionLabel = ({ promotion, currency }) => {
  const {
    sellingPrice,
    originalPrice,
    discountPercentage,
    additionalDiscountPercentage,
  } = promotion.price;

  return (
    <div>
      <span>
        {promotion.name}
      </span>
      <div className='promotion-group__pricing'>
        <span className='promotion-group__pricing--sell'>
          {currency} {sellingPrice}
        </span>
        <span className='promotion-group__pricing--original'>
          {currency} {originalPrice}
        </span>
        <span className='promotion-group__pricing--discount'>
          {discountPercentage}%
          {additionalDiscount(additionalDiscountPercentage)}
          &nbsp;OFF
        </span>
      </div>
    </div>
  )
};

const additionalDiscount = (additionalDiscountPercentage) => {
  if (additionalDiscountPercentage > 0) {
   return ` + ${additionalDiscountPercentage}%`;
  }
};

PromotionGroupOptionLabel.PropTypes = {
  promotion: PropTypes.shape({
    name: PropTypes.string.required,
    price: PropTypes.shape({
      originalPrice: PropTypes.number.required,
      sellingPrice: PropTypes.number.required,
      totalAmount: PropTypes.number.required,
      discountPercentage: PropTypes.number.required,
      additionalDiscountPercentage: PropTypes.number,
    }).required,
  }).required,
  currency: PropTypes.string.required,
};

export default PromotionGroupOptionLabel;



// WEBPACK FOOTER //
// ./src/Promotion/PromotionGroupOptionLabel.js